/**
 * Privacy Policy Page - Stroyma
 */

import { createFooter } from '../components/footer.js';
import { createNavigation } from '../components/navigation.js';
import { t } from '../lib/i18n.js';

export async function renderPrivacy() {
  const app = document.getElementById('app');
  app.innerHTML = '';

  // Navigation
  app.appendChild(await createNavigation());

  // Page Content
  const content = document.createElement('section');
  content.className = 'section';
  content.style.paddingTop = '100px';
  content.style.paddingBottom = '80px';
  content.innerHTML = `
    <div class="container">
      <div class="legal-page">
        <h1 class="legal-title">${t('privacy_title')}</h1>
        <p class="legal-updated">${t('privacy_last_updated')}</p>
        
        <div class="legal-content">
          <p class="legal-intro">${t('privacy_intro')}</p>
          
          <h2>${t('privacy_section_1_title')}</h2>
          <p>${t('privacy_section_1_content')}</p>
          
          <h2>${t('privacy_section_2_title')}</h2>
          <p>${t('privacy_section_2_content')}</p>
          
          <h2>${t('privacy_section_3_title')}</h2>
          <p>${t('privacy_section_3_content')}</p>
          
          <h2>${t('privacy_section_4_title')}</h2>
          <p>${t('privacy_section_4_content')}</p>
          
          <h2>${t('privacy_section_5_title')}</h2>
          <p>${t('privacy_section_5_content')}</p>
        </div>
        
        <div class="legal-back">
          <a href="/" class="btn btn-secondary" data-link>${t('legal_back_home')}</a>
        </div>
      </div>
    </div>
  `;
  app.appendChild(content);

  // Footer
  app.appendChild(createFooter());
}
